import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Widget.module.css';

export default function Widget(props) {

    const { widget } = props;
    const navigate = useNavigate();
    const [showCopied, setShowCopied] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const handleEdit = () => {
        navigate('/widgets', { state: { generator: widget } });
    };

    const handleCopyScript = async () => {
        const scriptUrl = `https://cta.lqr.ai/api/drawer/v2?id=${widget.id}`;
        const scriptTag = `<script src="${scriptUrl}"></script>`;
        
        try {
            await navigator.clipboard.writeText(scriptTag);
            setShowCopied(true);
            setTimeout(() => setShowCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy script:', err);
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric', 
            year: 'numeric' 
        });
    };

    return (
        <div className={styles.widget}>
            <div className={styles.header} onClick={() => setExpanded(!expanded)}>
                <h6 className={styles.title}>{widget.name || widget.title || 'Untitled Widget'}</h6>
                <div className={styles.actions} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.qrBadge}>QR: {widget.qr_id}</div>
                    <button className={styles.editBtn} onClick={handleEdit} title="Edit widget">
                        <i className="far fa-edit" />
                    </button>
                    <button 
                        className={`${styles.copyBtn} ${showCopied ? styles.copied : ''}`} 
                        onClick={handleCopyScript}
                        title="Copy script tag"
                    >
                        {showCopied ? <i className="far fa-check" /> : <i className="far fa-code" />}
                    </button>
                </div>
            </div>
            
            {expanded && (
                <>
                    <div className={styles.body}>
                        <div className={styles.detail}>
                            <span className={styles.label}>Tab Text:</span>
                            <span className={styles.value}>{widget.tab_text || '—'}</span>
                        </div>
                        <div className={styles.detail}>
                            <span className={styles.label}>Widget Name:</span>
                            <span className={styles.value}>{widget.name || '—'}</span>
                        </div>
                        <div className={styles.detail}>
                            <span className={styles.label}>Tab Color:</span>
                            <span className={styles.colorPreview}>
                                <span className={styles.colorSwatch} style={{ backgroundColor: widget.tab_color }} />
                                {widget.tab_color}
                            </span>
                        </div>
                        <div className={styles.detail}>
                            <span className={styles.label}>Size:</span>
                            <span className={styles.value}>{widget.drawer_width}×{widget.drawer_height}px</span>
                        </div>
                        <div className={styles.detail}>
                            <span className={styles.label}>Display:</span>
                            <span className={styles.value}>{formatDisplayOption(widget.display_on)}</span>
                        </div>
                        <div className={styles.detail}>
                            <span className={styles.label}>Created:</span>
                            <span className={styles.value}>{formatDate(widget.created_at)}</span>
                        </div>
                    </div>

                    <div className={styles.footer}>
                        <span className={styles.widgetId} title={widget.id}>
                            ID: {widget.id.substring(0, 8)}...
                        </span>
                    </div>
                </>
            )}
        </div>
    );
}

function formatDisplayOption(displayOn) {
    const options = {
        'all': 'All Devices',
        'mobile-only': 'Mobile Only',
        'mobile-onlyu': 'Mobile Only',
        'tablet-up': 'Tablet & Desktop',
        'tablet': 'Tablet Only',
        'desktop': 'Desktop Only'
    };
    return options[displayOn] || displayOn;
}